import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {checkoutUnreserveSpot} from '../../../actions/checkout';

class UnReserveSpotButton extends Component {
  constructor(props) {
    super(props);
    this.handleUnreserveClick = this.handleUnreserveClick.bind(this);
  }

  handleUnreserveClick() {
    const { spotId, checkoutUnreserveSpot } = this.props;
    checkoutUnreserveSpot(spotId);
  }

  render() {
    return (
      <a className="btn btn-alt btn-lg pull-right" onClick={this.handleUnreserveClick}>Unreserve</a>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({checkoutUnreserveSpot}, dispatch);
};

export default connect(undefined, mapDispatchToProps)(UnReserveSpotButton);



// WEBPACK FOOTER //
// ./src/containers/MapInfoBar/ParkingSpotInfoFooter/UnReserveSpotButton.js